import React from "react";
import { cn } from "@gettactic/helpers";
import { CheckCircleIcon, XCircleIcon } from "lucide-react";

export interface WizardReviewFeatureItemProps {
  label: string;
  enabled: boolean;
  className?: string;
}

/** A feature marked enabled or disabled. */
export const WizardReviewFeatureItem: React.FC<WizardReviewFeatureItemProps> = ({
  label,
  enabled,
  className
}) => (
  <div className={cn("flex items-center gap-2 text-sm", className)}>
    {/* The icon is the only sign of the state */}
    {enabled ? (
      <CheckCircleIcon
        role="img"
        aria-label="Enabled"
        className="size-4 text-green-500"
      />
    ) : (
      <XCircleIcon
        role="img"
        aria-label="Disabled"
        className="size-4 text-neutral-300"
      />
    )}
    <span className={enabled ? "text-neutral-900" : "text-content"}>{label}</span>
  </div>
);
